import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasPaginatorComponent } from './gas-paginator.component';
import { GasSelectModule } from '../../forms/gas-select/gas-select.module';

const COMPONENTS = [
  GasPaginatorComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasSelectModule,
  ],
})
export class GasPaginatorModule { }
